import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import dash from "../../../assets/images/dash.png"

const OfferingParkingAnalytics = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Parking Analytics"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Parking Analytics @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/route-optimization"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    {/* Summary Section */}
    <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
  {/* Text Section */}
  <div className="md:w-1/2">
    <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
      Summary
    </h4>
    <p className="text-black mb-4 text-lg">
      Parking Analytics transforms raw parking data into actionable intelligence, enabling data-driven decision making for urban planners and parking operators. Our advanced analytics platform reveals patterns, predicts demand, and optimizes operations through comprehensive data visualization and machine learning.
    </p>
    <p className="text-black text-lg">
      Municipalities and parking operators leveraging parking analytics achieve 20–40% greater facility utilization, 15–30% increased revenue, and significantly improved customer satisfaction through predictive management and smart resource allocation.
    </p>
  </div>

  {/* Image Section */}
  <div className="md:w-1/2">
    <img
      src={dash}
      alt="Parking Analytics Dashboard"
      className="w-full h-auto rounded-lg shadow-md"
    />
  </div>
</div>


    {/* Introduction Section */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        Introduction
      </h4>
      <p className="text-black mb-4 text-lg">
        In the era of smart cities, parking management has evolved from simple space monitoring to sophisticated data analytics. Parking Analytics systems aggregate data from sensors, payment systems, and user behavior to provide comprehensive insights into parking operations.
      </p>
      <p className="text-black text-lg">
        By applying artificial intelligence and predictive modeling to parking data, our solutions help cities and operators anticipate demand, optimize pricing, and improve overall parking ecosystem efficiency.
      </p>
    </div>

    {/* Key Features Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-4 text-black">
        Key Features of Parking Analytics:
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>
          <strong>Real-Time Occupancy Monitoring:</strong> Live dashboards showing space utilization across facilities
        </li>
        <li>
          <strong>Demand Forecasting:</strong> AI-powered predictions of parking needs by time, day, and season
        </li>
        <li>
          <strong>Revenue Optimization:</strong> Dynamic pricing recommendations based on demand patterns
        </li>
        <li>
          <strong>User Behavior Analysis:</strong> Insights into dwell times, frequency, and payment methods
        </li>
        <li>
          <strong>Comparative Benchmarking:</strong> Performance metrics across locations and time periods
        </li>
        <li>
          <strong>Custom Reporting:</strong> Tailored analytics for different stakeholders (operators, city planners, businesses)
        </li>
      </ul>
    </div>

    {/* Benefits Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-3 text-black">
        Operational Benefits
      </h5>
      <p className="text-black text-lg mb-4">
        Implementing parking analytics delivers transformative advantages:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>25-40% improvement in parking space turnover rates</li>
        <li>15-30% increase in revenue through optimized pricing strategies</li>
        <li>20-35% reduction in congestion through better demand distribution</li>
        <li>Predictive maintenance scheduling for parking infrastructure</li>
        <li>Data-driven decisions for facility expansion/contraction</li>
        <li>Enhanced customer experience through demand-responsive operations</li>
      </ul>
    </div>

    {/* Implementation Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-3 text-black">
        Implementation Considerations
      </h5>
      <p className="text-black text-lg mb-4">
        Successful parking analytics deployment requires:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Comprehensive data collection infrastructure (sensors, payment systems)</li>
        <li>Secure data aggregation and storage solutions</li>
        <li>Integration with existing parking management systems</li>
        <li>Customizable dashboard development for different user needs</li>
        <li>Staff training on data interpretation and system operation</li>
        <li>Regular system updates to incorporate new data sources</li>
      </ul>
    </div>

    {/* Ajeevi's Contribution Section */}
    <div>
      <h5 className="text-xl font-semibold mb-3 text-black">
        Ajeevi's Parking Analytics Solutions
      </h5>
      <p className="text-black mb-4 text-lg">
        Ajeevi offers cutting-edge parking analytics platforms:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>
          <strong>Smart Parking Intelligence:</strong> Comprehensive analytics suite with customizable dashboards
        </li>
        <li>
          <strong>Predictive Parking Engine:</strong> AI-driven demand forecasting and recommendations
        </li>
        <li>
          <strong>Revenue Optimization Module:</strong> Dynamic pricing simulations and strategies
        </li>
        <li>
          <strong>Mobile Analytics:</strong> Real-time insights for field operations via smartphone
        </li>
        <li>
          <strong>API Integration:</strong> Seamless connection with third-party urban data systems
        </li>
      </ul>
      <p className="text-black text-lg">
        Discover how Ajeevi's Parking Analytics can transform your operations. Visit{" "}
        <a
          href="http://www.ajeevi.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#00D084] hover:underline"
        >
          www.ajeevi.com
        </a>{" "}
        for more information.
      </p>
    </div>
  </div>
</div>
    </>
  );
};

export default OfferingParkingAnalytics;